import { render, staticRenderFns } from "./pagetemplate.vue?vue&type=template&id=75684f57&"
import script from "./pagetemplate.vue?vue&type=script&lang=js&"
export * from "./pagetemplate.vue?vue&type=script&lang=js&"
import style0 from "./pagetemplate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports